module.exports = __webpack_public_path__ + "static/media/game1.5c7846c3.png";